module.exports = __webpack_public_path__ + "img/botswana.c604a977.png";